import { Component, Input, OnInit } from '@angular/core'
import { financeFilter } from '../../models/finance.models'
import { TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'

@Component({
	selector: 'app-financial-table',
	templateUrl: './financial-table.component.html',
	styleUrls: ['./financial-table.component.scss'],
})
export class FinancialTableComponent implements OnInit {
	@Input() activeStatus: number = 0
	@Input() listData!: any
	@Input() totalCount: number = 0
	@Input() financialFilter: financeFilter = {
		countryId: 224,
		searchText: '',
		activeTab: 0,
		startDate: null,
		endDate: null,
		serviceProviderId: null,
		branchId: null,
		clientId: null,
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		fixedAmount: null,
		fromAmount: null,
		toAmount: null,
	}
	constructor(public translate: TranslateService, private router: Router) {}

	ngOnInit(): void {}
	redirect(id?: number, actor?: number) {
		this.router.navigateByUrl(
			this.financialFilter.activeTab <= 3 || this.financialFilter.activeTab == 6
				? `/layout/booking/booking-details/${id}`
				: actor == 1
				? `/layout/clients/client-profile/${id}`
				: `/layout/wallet/sp-wallet/${id}`
		)
	}
}
